// 增值服务模块多语言配置
export const addedServices = {
  'zh-CN': {
    // 打卡数据详情页面
    clockDataDetail: '打卡数据详情',
    name: '姓名',
    phone: '电话',
    totalClockDays: '累计打卡天数',
    firstClockTime: '首次打卡时间',
    clockRecord: '打卡记录',
    goodMorningClock: '早安打卡',
    goodNightClock: '晚安打卡',
    
    // 打卡数据列表页面
    pleaseSelect: '请选择',
    totalClockDaysHighToLow: '累计打卡天数从高到低',
    totalClockDaysLowToHigh: '累计打卡天数从低到高',
    export: '导出',
    number: '编号',
    mobilePhone: '手机号',
    firstClockTimeLabel: '初次打卡时间',
    operation: '操作',
    detail: '详情',
    
    // 分类管理页面
    newCategory: '新建分类',
    categoryName: '分类名称',
    sort: '排序',
    status: '状态',
    turnOn: '开启',
    turnOff: '关闭',
    edit: '编辑',
    delete: '删除',
    confirm: '确定',
    cancel: '取消',
    confirmDelete: '确认删除吗？',
    pleaseEnterName: '请输入名称',
    pleaseEnterCategoryName: '请输入分类名称',
    deleteSuccess: '删除成功',
    saveSuccess: '保存成功',
    
    // 通用文本
    submit: '提交',
    reset: '重置',
    search: '搜索',
    loading: '加载中...',
    noData: '暂无数据',
    error: '错误',
    success: '成功',
    warning: '警告',
    info: '信息',
    
    // 自定义设置页面
    menuStatus: '菜单状态',
    menuNameLeft: '菜单名称(左侧)',
    menuNameRight: '菜单名称(右侧)',
    pleaseEnterContent: '请输入内容',
    note: '注：该文案原为需求广场',
    note2: '注：该文案原为产品中心',
    topCarousel: '顶部轮播图',
    clickToUpload: '点击上传',
    uploadImageTip: '上传图片的最佳尺寸：750像素*422像素，其他尺寸会影响页面效果，格式png，jpeg，jpg。大小不超过2M，最少上传1张最多可上传6张',
    save: '保存',
    
    // 需求列表页面
    selectStatus: '选择状态',
    all: '全部',
    pendingReview: '待审核',
    rejected: '已驳回',
    published: '已发布',
    publishDemand: '发布需求',
    serialNumber: '序号',
    createTime: '创建时间',
    publisher: '发布人',
    content: '内容',
    image: '图片',
    remark: '备注',
    pendingReviewStatus: '待审核',
    approved: '已通过',
    rejectedReason: '已驳回(原因：',
    withdraw: '撤回',
    confirmWithdraw: '确认撤回吗？',
    
    // 需求发布表单页面
    selectCategory: '选择分类',
    demandDescription: '需求描述',
    addImage: '添加图片',
    uploadImageTip2: '上传图片的最佳尺寸：750像素*422像素，其他尺寸会影响页面效果，格式png，jpeg，jpg。大小不超过2M，最少上传1张最多可上传6张',
    remarkLabel: '备注',
    location: '所在位置',
    pleaseEnterAddress: '请输入地址',
    userAgreement: '我已阅读用户协议',
    saveToDraft: '保存到草稿',
    publish: '发布',
    userAgreementTitle: '用户协议',
    userAgreementContent1: '本小程序用户的言行不得违反《计算机信息网络国际联网安全保护管理办法》、《互联网信息服务管理办法》、《互联网电子公告服务管理规定》、《维护互联网安 全的决定》等相关法律规定，不得在此发布含有下列内容之一的信息。',
    userAgreementContent2: '1、违反宪法或法律法规规定的；',
    userAgreementContent3: '2、泄露国家秘密，颠覆国家政权，推翻社会主义制度，煽动分裂国家、破坏国家统一的；',
    userAgreementContent4: '3、损害国家荣誉和利益的，损害公共利益的；',
    userAgreementContent5: '4、宣扬恐怖主义、极端主义，煽动民族仇恨、民族歧视，破坏民族团结的；',
    userAgreementContent6: '5、破坏国家宗教政策，宣扬邪教和封建迷信的；',
    userAgreementContent7: '6、散布谣言，扰乱社会秩序，破坏社会稳定的；',
    userAgreementContent8: '7、布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；',
    userAgreementContent9: '8、侮辱或者诽谤他人，侵害他人名誉、隐私、知识产权和其他合法权益的；',
    userAgreementContent10: '9、含有法律、行政法规禁止的其他内容的。',
    userAgreementContent11: '10、本小程序认为不利于小程序生态、可能给小程序造成损失的内容。',
    pleaseSelectCategory: '请选择选择分类',
    pleaseEnterLocation: '请输入所在位置',
    pleaseCheckUserAgreement: '请勾选用户协议',
    publishSuccess: '发布成功',
    publishFailed: '发布失败',
    uploading: '正在上传',
    uploadSuccess: '上传成功',
    uploadImageFormatError: '上传头像图片只能是 JPG 格式!',
    uploadImageSizeError: '上传头像图片大小不能超过 2MB!',
    uploadImageCountError: '最少上传1张最多可上传6张',
    leftSideUploadError: '左侧最少上传1张最多可上传6张',
    rightSideUploadError: '右侧侧最少上传1张最多可上传6张',
    auditPassedCanOnline: '审核通过的需求才能上架',
    
    // 草稿页面
    unsubmitted: '未提交',
    reviewed: '已审核',
    submitReview: '提交审核',
    online: '上线',
    
    // 需求审核页面
    batchReject: '批量驳回',
    batchPass: '批量通过',
    companyName: '公司名称',
    reject: '驳回',
    pass: '通过',
    rejectReason: '驳回原因：',
    pleaseEnterRejectReason: '请输入驳回原因',
    confirmPassAudit: '确认通过审核吗？',
    pleaseSelectDemand: '请选择需求',
    
    // 名片审核页面
    position: '职位',
    businessCardUser: '名片使用人',
    businessCardStatus: '状态',
    
    // 海报图集页面
    newPosterModule: '新增海报模块',
    posterModuleTitle: '海报模块标题',
    icon: '图标',
    imageCount: '图片数量',
    confirmDeletePoster: '确定删除此海报模块?',
    tip: '提示',
    operationSuccess: '操作成功！',
    
    // 海报图集详情页面
    titleName: '标题名称',
    pleaseEnterTitleContent: '请输入标题内容',
    titleIcon: '标题图标',
    uploadImageTip: '上传图片格式png，jpeg，jpg。 大小不超过2M,图片大小100px*100px',
    posterImage: '海报图片',
    title: '标题',
    pleaseEnterImageTitle: '请输入图片标题',
    peopleCount: '人数',
    pleaseEnterVirtualUseCount: '请输入虚拟使用人数',
    actualCount: '实际人数',
    imageLabel: '图片',
    uploadImageTip2: '上传图片格式png，jpeg，jpg。 大小不超过2M,图片大小750px*1034px',
    add: '添加',
    maxAdd50: '最多可添加50个',
    uploadImageSizeError: '上传视频大小不能超过 2MB!图片大小100px*100px',
    uploadImageResolutionTip: '上传图片分辨率建议100px*100px,宽度不可超过100px，高度不超过100px!',
    uploadImageSizeError2: '上传图片大小不能超过 2MB!图片大小750px*1034px',
    uploadImageResolutionTip2: '上传图片分辨率建议750px*1034px,宽度不可超过750px，高度不超过1034px!',
    
    // 缺失的键值对
    rejectedStatus: '已驳回状态',
    alreadyOffShelf: '已下架',
    alreadyOnShelf: '已上架',
    demandList: '需求列表',
    draftBox: '草稿箱',
    productName: '产品名称',
    eachEnterprise: '每个企业',
    canFreePublish: '可以免费发布',
    demandCount: '条需求,和',
    productCount: '件产品',
    reportTime: '举报时间',
    reportReason: '举报原因',
    customSettings: '自定义设置',
    categoryManagement: '分类管理',
    daily: '每日',
    weekly: '每周',
    monthly: '每月',
    price: "价格"
  },
  'zh-TW': {
    // 打卡数据详情页面
    clockDataDetail: '打卡數據詳情',
    name: '姓名',
    phone: '電話',
    totalClockDays: '累計打卡天數',
    firstClockTime: '首次打卡時間',
    clockRecord: '打卡記錄',
    goodMorningClock: '早安打卡',
    goodNightClock: '晚安打卡',
    
    // 打卡数据列表页面
    pleaseSelect: '請選擇',
    totalClockDaysHighToLow: '累計打卡天數從高到低',
    totalClockDaysLowToHigh: '累計打卡天數從低到高',
    export: '導出',
    number: '編號',
    mobilePhone: '手機號',
    firstClockTimeLabel: '初次打卡時間',
    operation: '操作',
    detail: '詳情',
    
    // 分类管理页面
    newCategory: '新建分類',
    categoryName: '分類名稱',
    sort: '排序',
    status: '狀態',
    turnOn: '開啟',
    turnOff: '關閉',
    edit: '編輯',
    delete: '刪除',
    confirm: '確定',
    cancel: '取消',
    confirmDelete: '確認刪除嗎？',
    pleaseEnterName: '請輸入名稱',
    pleaseEnterCategoryName: '請輸入分類名稱',
    deleteSuccess: '刪除成功',
    saveSuccess: '保存成功',
    
    // 通用文本
    submit: '提交',
    reset: '重置',
    search: '搜索',
    loading: '加載中...',
    noData: '暫無數據',
    error: '錯誤',
    success: '成功',
    warning: '警告',
    info: '信息',
    
    // 自定义设置页面
    menuStatus: '菜單狀態',
    menuNameLeft: '菜單名稱(左側)',
    menuNameRight: '菜單名稱(右側)',
    pleaseEnterContent: '請輸入內容',
    note: '注：該文案原為需求廣場',
    note2: '注：該文案原為產品中心',
    topCarousel: '頂部輪播圖',
    clickToUpload: '點擊上傳',
    uploadImageTip: '上傳圖片的最佳尺寸：750像素*422像素，其他尺寸會影響頁面效果，格式png，jpeg，jpg。大小不超過2M，最少上傳1張最多可上傳6張',
    save: '保存',
    
    // 需求列表页面
    selectStatus: '選擇狀態',
    all: '全部',
    pendingReview: '待審核',
    rejected: '已駁回',
    published: '已發布',
    publishDemand: '發布需求',
    serialNumber: '序號',
    createTime: '創建時間',
    publisher: '發布人',
    content: '內容',
    image: '圖片',
    remark: '備註',
    pendingReviewStatus: '待審核',
    approved: '已通過',
    rejectedReason: '已駁回(原因：',
    withdraw: '撤回',
    confirmWithdraw: '確認撤回嗎？',
    
    // 需求发布表单页面
    selectCategory: '選擇分類',
    demandDescription: '需求描述',
    addImage: '添加圖片',
    uploadImageTip2: '上傳圖片的最佳尺寸：750像素*422像素，其他尺寸會影響頁面效果，格式png，jpeg，jpg。大小不超過2M，最少上傳1張最多可上傳6張',
    remarkLabel: '備註',
    location: '所在位置',
    pleaseEnterAddress: '請輸入地址',
    userAgreement: '我已閱讀用戶協議',
    saveToDraft: '保存到草稿',
    publish: '發布',
    userAgreementTitle: '用戶協議',
    userAgreementContent1: '本小程序用戶的言行不得違反《計算機信息網絡國際聯網安全保護管理辦法》、《互聯網信息服務管理辦法》、《互聯網電子公告服務管理規定》、《維護互聯網安 全的決定》等相關法律規定，不得在此發布含有下列內容之一的信息。',
    userAgreementContent2: '1、違反憲法或法律法規規定的；',
    userAgreementContent3: '2、泄露國家秘密，顛覆國家政權，推翻社會主義制度，煽動分裂國家、破壞國家統一的；',
    userAgreementContent4: '3、損害國家榮譽和利益的，損害公共利益的；',
    userAgreementContent5: '4、宣揚恐怖主義、極端主義，煽動民族仇恨、民族歧視，破壞民族團結的；',
    userAgreementContent6: '5、破壞國家宗教政策，宣揚邪教和封建迷信的；',
    userAgreementContent7: '6、散布謠言，擾亂社會秩序，破壞社會穩定的；',
    userAgreementContent8: '7、布淫穢、色情、賭博、暴力、凶殺、恐怖或者教唆犯罪的；',
    userAgreementContent9: '8、侮辱或者誹謗他人，侵害他人名譽、隱私、知識產權和其他合法權益的；',
    userAgreementContent10: '9、含有法律、行政法規禁止的其他內容的。',
    userAgreementContent11: '10、本小程序認為不利於小程序生態、可能給小程序造成損失的內容。',
    pleaseSelectCategory: '請選擇選擇分類',
    pleaseEnterLocation: '請輸入所在位置',
    pleaseCheckUserAgreement: '請勾選用戶協議',
    publishSuccess: '發布成功',
    publishFailed: '發布失敗',
    uploading: '正在上傳',
    uploadSuccess: '上傳成功',
    uploadImageFormatError: '上傳頭像圖片只能是 JPG 格式!',
    uploadImageSizeError: '上傳頭像圖片大小不能超過 2MB!',
    uploadImageCountError: '最少上傳1張最多可上傳6張',
    leftSideUploadError: '左側最少上傳1張最多可上傳6張',
    rightSideUploadError: '右側側最少上傳1張最多可上傳6張',
    auditPassedCanOnline: '審核通過的需求才能上架',
    
    // 草稿页面
    unsubmitted: '未提交',
    reviewed: '已審核',
    submitReview: '提交審核',
    online: '上線',
    
    // 需求审核页面
    batchReject: '批量駁回',
    batchPass: '批量通過',
    companyName: '公司名稱',
    reject: '駁回',
    pass: '通過',
    rejectReason: '駁回原因：',
    pleaseEnterRejectReason: '請輸入駁回原因',
    confirmPassAudit: '確認通過審核嗎？',
    pleaseSelectDemand: '請選擇需求',
    
    // 名片审核页面
    position: '職位',
    businessCardUser: '名片使用人',
    businessCardStatus: '狀態',
    
    // 海报图集页面
    newPosterModule: '新增海報模塊',
    posterModuleTitle: '海報模塊標題',
    icon: '圖標',
    imageCount: '圖片數量',
    confirmDeletePoster: '確定刪除此海報模塊?',
    tip: '提示',
    operationSuccess: '操作成功！',
    
    // 海报图集详情页面
    titleName: '標題名稱',
    pleaseEnterTitleContent: '請輸入標題內容',
    titleIcon: '標題圖標',
    uploadImageTip: '上傳圖片格式png，jpeg，jpg。 大小不超過2M,圖片大小100px*100px',
    posterImage: '海報圖片',
    title: '標題',
    pleaseEnterImageTitle: '請輸入圖片標題',
    peopleCount: '人數',
    pleaseEnterVirtualUseCount: '請輸入虛擬使用人數',
    actualCount: '實際人數',
    imageLabel: '圖片',
    uploadImageTip2: '上傳圖片格式png，jpeg，jpg。 大小不超過2M,圖片大小750px*1034px',
    add: '添加',
    maxAdd50: '最多可添加50個',
    uploadImageSizeError: '上傳視頻大小不能超過 2MB!圖片大小100px*100px',
    uploadImageResolutionTip: '上傳圖片分辨率建議100px*100px,寬度不可超過100px，高度不超過100px!',
    uploadImageSizeError2: '上傳圖片大小不能超過 2MB!圖片大小750px*1034px',
    uploadImageResolutionTip2: '上傳圖片分辨率建議750px*1034px,寬度不可超過750px，高度不超過1034px!',
    
    // 缺失的键值对
    rejectedStatus: '已駁回狀態',
    alreadyOffShelf: '已下架',
    alreadyOnShelf: '已上架',
    demandList: '需求列表',
    draftBox: '草稿箱',
    productName: '產品名稱',
    eachEnterprise: '每個企業',
    canFreePublish: '可以免費發布',
    demandCount: '條需求,和',
    productCount: '件產品',
    reportTime: '舉報時間',
    reportReason: '舉報原因',
    customSettings: '自定義設置',
    categoryManagement: '分類管理',
    daily: '每日',
    weekly: '每週',
    monthly: '每月',
    price: "價格"   
  },
  'en': {
    // 打卡数据详情页面
    clockDataDetail: 'Clock Data Detail',
    name: 'Name',
    phone: 'Phone',
    totalClockDays: 'Total Clock Days',
    firstClockTime: 'First Clock Time',
    clockRecord: 'Clock Record',
    goodMorningClock: 'Good Morning Clock',
    goodNightClock: 'Good Night Clock',
    
    // 打卡数据列表页面
    pleaseSelect: 'Please Select',
    totalClockDaysHighToLow: 'Total Clock Days High to Low',
    totalClockDaysLowToHigh: 'Total Clock Days Low to High',
    export: 'Export',
    number: 'Number',
    mobilePhone: 'Mobile Phone',
    firstClockTimeLabel: 'First Clock Time',
    operation: 'Operation',
    detail: 'Detail',
    
    // 分类管理页面
    newCategory: 'New Category',
    categoryName: 'Category Name',
    sort: 'Sort',
    status: 'Status',
    turnOn: 'Turn On',
    turnOff: 'Turn Off',
    edit: 'Edit',
    delete: 'Delete',
    confirm: 'Confirm',
    cancel: 'Cancel',
    confirmDelete: 'Confirm Delete?',
    pleaseEnterName: 'Please Enter Name',
    pleaseEnterCategoryName: 'Please Enter Category Name',
    deleteSuccess: 'Delete Success',
    saveSuccess: 'Save Success',
    
    // 通用文本
    submit: 'Submit',
    reset: 'Reset',
    search: 'Search',
    loading: 'Loading...',
    noData: 'No Data',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Info',
    
    // 自定义设置页面
    menuStatus: 'Menu Status',
    menuNameLeft: 'Menu Name (Left)',
    menuNameRight: 'Menu Name (Right)',
    pleaseEnterContent: 'Please Enter Content',
    note: 'Note: This text was originally "Demand Square"',
    note2: 'Note: This text was originally "Product Center"',
    topCarousel: 'Top Carousel',
    clickToUpload: 'Click to Upload',
    uploadImageTip: 'The best size for uploading images: 750px*422px, other sizes will affect the page effect, formats png, jpeg, jpg. Size should not exceed 2M, minimum upload 1 sheet maximum upload 6 sheets',
    save: 'Save',
    
    // 需求列表页面
    selectStatus: 'Select Status',
    all: 'All',
    pendingReview: 'Pending Review',
    rejected: 'Rejected',
    published: 'Published',
    publishDemand: 'Publish Demand',
    serialNumber: 'Serial Number',
    createTime: 'Create Time',
    publisher: 'Publisher',
    content: 'Content',
    image: 'Image',
    remark: 'Remark',
    pendingReviewStatus: 'Pending Review',
    approved: 'Approved',
    rejectedReason: 'Rejected (Reason: ',
    withdraw: 'Withdraw',
    confirmWithdraw: 'Confirm Withdraw?',
    
    // 需求发布表单页面
    selectCategory: 'Select Category',
    demandDescription: 'Demand Description',
    addImage: 'Add Image',
    uploadImageTip2: 'The best size for uploading images: 750px*422px, other sizes will affect the page effect, formats png, jpeg, jpg. Size should not exceed 2M, minimum upload 1 sheet maximum upload 6 sheets',
    remarkLabel: 'Remark',
    location: 'Location',
    pleaseEnterAddress: 'Please Enter Address',
    userAgreement: 'I have read the user agreement',
    saveToDraft: 'Save to Draft',
    publish: 'Publish',
    userAgreementTitle: 'User Agreement',
    userAgreementContent1: 'The words and deeds of users of this mini program must not violate the "Computer Information Network International Internet Security Protection Management Measures", "Internet Information Service Management Measures", "Internet Electronic Bulletin Service Management Regulations", "Decision on Maintaining Internet Security" and other relevant legal provisions, and must not publish information containing any of the following contents here.',
    userAgreementContent2: '1. Violating the Constitution or laws and regulations;',
    userAgreementContent3: '2. Leaking state secrets, subverting state power, overthrowing the socialist system, inciting national division and undermining national unity;',
    userAgreementContent4: '3. Damaging national honor and interests, damaging public interests;',
    userAgreementContent5: '4. Promoting terrorism and extremism, inciting ethnic hatred and ethnic discrimination, undermining ethnic unity;',
    userAgreementContent6: '5. Undermining national religious policies and promoting cults and feudal superstitions;',
    userAgreementContent7: '6. Spreading rumors, disrupting social order and undermining social stability;',
    userAgreementContent8: '7. Publishing obscene, pornographic, gambling, violent, murderous, terrorist or inciting crime;',
    userAgreementContent9: '8. Insulting or defaming others, infringing on others\' reputation, privacy, intellectual property rights and other legitimate rights and interests;',
    userAgreementContent10: '9. Containing other content prohibited by laws and administrative regulations.',
    userAgreementContent11: '10. Content that this mini program considers detrimental to the mini program ecosystem and may cause losses to the mini program.',
    pleaseSelectCategory: 'Please Select Category',
    pleaseEnterLocation: 'Please Enter Location',
    pleaseCheckUserAgreement: 'Please check the user agreement',
    publishSuccess: 'Publish Success',
    publishFailed: 'Publish Failed',
    uploading: 'Uploading...',
    uploadSuccess: 'Upload Success',
    uploadImageFormatError: 'Upload avatar image can only be JPG format!',
    uploadImageSizeError: 'Upload avatar image size cannot exceed 2MB!',
    uploadImageCountError: 'Minimum upload 1 sheet maximum upload 6 sheets',
    leftSideUploadError: 'Left side minimum upload 1 sheet maximum upload 6 sheets',
    rightSideUploadError: 'Right side minimum upload 1 sheet maximum upload 6 sheets',
    auditPassedCanOnline: 'Only demands that have passed review can be online',
    
    // 草稿页面
    unsubmitted: 'Unsubmitted',
    reviewed: 'Reviewed',
    submitReview: 'Submit Review',
    online: 'Online',
    
    // 需求审核页面
    batchReject: 'Batch Reject',
    batchPass: 'Batch Pass',
    companyName: 'Company Name',
    reject: 'Reject',
    pass: 'Pass',
    rejectReason: 'Reject Reason: ',
    pleaseEnterRejectReason: 'Please Enter Reject Reason',
    confirmPassAudit: 'Confirm Pass Audit?',
    pleaseSelectDemand: 'Please Select Demand',
    
    // 名片审核页面
    position: 'Position',
    businessCardUser: 'Business Card User',
    businessCardStatus: 'Status',
    
    // 海报图集页面
    newPosterModule: 'New Poster Module',
    posterModuleTitle: 'Poster Module Title',
    icon: 'Icon',
    imageCount: 'Image Count',
    confirmDeletePoster: 'Confirm Delete This Poster Module?',
    tip: 'Tip',
    operationSuccess: 'Operation Success!',
    
    // 海报图集详情页面
    titleName: 'Title Name',
    pleaseEnterTitleContent: 'Please Enter Title Content',
    titleIcon: 'Title Icon',
    uploadImageTip: 'Upload image format png, jpeg, jpg. Size should not exceed 2M, image size 100px*100px',
    posterImage: 'Poster Image',
    title: 'Title',
    pleaseEnterImageTitle: 'Please Enter Image Title',
    peopleCount: 'People Count',
    pleaseEnterVirtualUseCount: 'Please Enter Virtual Use Count',
    actualCount: 'Actual Count',
    imageLabel: 'Image',
    uploadImageTip2: 'Upload image format png, jpeg, jpg. Size should not exceed 2M, image size 750px*1034px',
    add: 'Add',
    maxAdd50: 'Maximum 50 can be added',
    uploadImageSizeError: 'Upload video size cannot exceed 2MB! Image size 100px*100px',
    uploadImageResolutionTip: 'Upload image resolution recommended 100px*100px, width cannot exceed 100px, height cannot exceed 100px!',
    uploadImageSizeError2: 'Upload image size cannot exceed 2MB! Image size 750px*1034px',
    uploadImageResolutionTip2: 'Upload image resolution recommended 750px*1034px, width cannot exceed 750px, height cannot exceed 1034px!',
    
    // 缺失的键值对
    rejectedStatus: 'Rejected Status',
    alreadyOffShelf: 'Already Off Shelf',
    alreadyOnShelf: 'Already On Shelf',
    demandList: 'Demand List',
    draftBox: 'Draft Box',
    productName: 'Product Name',
    eachEnterprise: 'Each Enterprise',
    canFreePublish: 'Can Free Publish',
    demandCount: 'Demand Count, and',
    productCount: 'Product Count',
    reportTime: 'Report Time',
    reportReason: 'Report Reason',
    customSettings: 'Custom Settings',
    categoryManagement: 'Category Management',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    price: "Price"
  }
}; 